import { HubPersona, Person, PersonType } from '../../shared';
import { Sorting } from '../../appstate';
import { getInitials } from '@fluentui/utilities/lib/initials';

export const NUMBER_ONLY_INITIAL = '#';

// Todo: This is a naive approach and does not take language specific rules into consideration
export function initial(persona: HubPersona, sorting: Sorting, emptyMarker: string): string {
    let name: string;

    switch (persona.type) {
        case PersonType.Person:
            name =
                sorting === Sorting.ByFirstName
                    ? getPersonaNameFirstLast(persona)
                    : getPersonaNameLastFirst(persona);
            break;
        case PersonType.PrivateDistributionList:
        case PersonType.PublicDistributionList:
            name = persona.info.displayNameFirstLast; // For PDLs, there is no first-last or last-first difference
            break;
        case PersonType.Group:
        case PersonType.GroupBasicData:
            name = persona.displayName; // Neither for favorites or groups
            break;
        case PersonType.FavoritePerson:
        case PersonType.FavoritePrivateDistributionList:
        case PersonType.FavoriteUnifiedGroup:
        case PersonType.Generic:
            name = persona.info.displayName;
            break;
        default:
            throw new Error('initial Error: HubPersonaType not supported');
    }

    const initials = getInitials(name, false);
    const initial = initials && initials.length > 0 ? initials[0] : emptyMarker;

    // If the initial is a number, show #
    // in cases when name only consists of numbers, getInitials returns empty string
    return /^\d+$/.test(initial) || /^\d+$/.test(name) ? NUMBER_ONLY_INITIAL : initial;
}

/**
 * Returns the persona name to use to calculate the group initial based on first-last sorting
 * @param persona The persona
 */
function getPersonaNameFirstLast(persona: Person): string {
    if (persona.info.displayNameFirstLast) {
        return persona.info.displayNameFirstLast;
    }

    if (persona.info.givenName || persona.info.surname) {
        return [persona.info.givenName, persona.info.surname].join().trim();
    }

    return persona.info.originalDisplayName;
}

/**
 * Returns the persona name to use to calculate the group initial based on last-first-sorting
 * @param persona The persona
 */
function getPersonaNameLastFirst(persona: Person): string {
    if (persona.info.displayNameLastFirst) {
        return persona.info.displayNameLastFirst;
    }

    if (persona.info.givenName || persona.info.surname) {
        return [persona.info.surname, persona.info.givenName].join().trim();
    }

    return persona.info.originalDisplayName;
}
